// extracted by mini-css-extract-plugin
export default {"Box":"AttestationsIndexWithFilter-module__Box--urAQr","Box_1":"AttestationsIndexWithFilter-module__Box_1--rxgQc","Heading":"AttestationsIndexWithFilter-module__Heading--Rt8ia"};